import { isBuyerFeeType } from './buyerFeeUtils';

export const calculateBuyerFee = (bidAmount, feeConfig) => {
    if (isBuyerFeeType(feeConfig?.add_buyer_fees, 'no_fees')) return 0
    if (feeConfig?.fees && feeConfig.fees !== '') return Number(feeConfig.fees)
    if (feeConfig?.percentage && feeConfig.percentage !== '')
        return bidAmount * (Number(feeConfig.percentage) / 100)
    return 0
}
